var map = {
	"./aek-athens-logo-icon.png": 61709,
	"./afc-bournemouth-logo-icon.png": 60537,
	"./ajaccio-logo-icon.png": 98910,
	"./ajax-logo-icon.png": 66306,
	"./alaves-logo-icon.png": 46946,
	"./albania-logo-icon.png": 74450,
	"./algeria-logo-icon.png": 77271,
	"./almeria-logo-icon.png": 19697,
	"./amazulu-logo-icon.png": 42031,
	"./angers-sco-logo-icon.png": 46878,
	"./angola-logo-icon.png": 52090,
	"./antwerp-logo-icon.png": 53519,
	"./argentina-logo-icon.png": 68281,
	"./aris-limassol-logo-icon.png": 47012,
	"./arsenal-logo-icon.png": 62644,
	"./astana-logo-icon.png": 69726,
	"./aston-villa-logo-icon.png": 70598,
	"./atalanta-logo-icon.png": 92764,
	"./athletic-club-logo-icon.png": 33851,
	"./atletic-club-d'escaldes-logo-icon.png": 84489,
	"./atletico-madrid-logo-icon.png": 6019,
	"./australia-logo-icon.png": 70616,
	"./austria-logo-icon.png": 43083,
	"./auxerre-logo-icon.png": 55958,
	"./ballkani-logo-icon.png": 52916,
	"./barcelona-logo-icon.png": 99093,
	"./baroka-logo-icon.png": 11466,
	"./bate-logo-icon.png": 5238,
	"./bayer-leverkusen-logo-icon.png": 98472,
	"./bayern-munchen-logo-icon.png": 10866,
	"./belgium-logo-icon.png": 68033,
	"./benfica-logo-icon.png": 53502,
	"./bodo-glimt-logo-icon.png": 33556,
	"./bologna-logo-icon.png": 47760,
	"./bordeaux-logo-icon.png": 97862,
	"./borussia-dortmund-logo-icon.png": 12480,
	"./braga-logo-icon.png": 37575,
	"./brazil-logo-icon.png": 10966,
	"./breidablik-logo-icon.png": 25989,
	"./brentford-logo-icon.png": 70630,
	"./brest-logo-icon.png": 76266,
	"./brighton-&-hove-albion-logo-icon.png": 44319,
	"./buducnost-logo-icon.png": 75823,
	"./burkina-faso-logo-icon.png": 92316,
	"./burnley-logo-icon.png": 35453,
	"./cabo-verde-logo-icon.png": 36796,
	"./cadiz-logo-icon.png": 29723,
	"./cagliari-logo-icon.png": 86332,
	"./cameroon-logo-icon.png": 39292,
	"./canada-logo-icon.png": 78422,
	"./cape-town-city-logo-icon.png": 38086,
	"./cape-town-spurs-logo-icon.png": 21100,
	"./celta-de-vigo-logo-icon.png": 23895,
	"./celtic-logo-icon.png": 41352,
	"./chelsea-logo-icon.png": 27625,
	"./china-pr-logo-icon.png": 59652,
	"./chippa-united-logo-icon.png": 99163,
	"./clermont-logo-icon.png": 66178,
	"./club-brugge-logo-icon.png": 78383,
	"./colombia-logo-icon.png": 28018,
	"./como-logo-icon.png": 20882,
	"./congo-dr-logo-icon.png": 71309,
	"./costa-rica-logo-icon.png": 458,
	"./cote-d'ivoire-logo-icon.png": 59431,
	"./cremonese-logo-icon.png": 75837,
	"./croatia-logo-icon.png": 63205,
	"./crvena-zvezda-logo-icon.png": 21706,
	"./crystal-palace-logo-icon.png": 66363,
	"./czech-republic-logo-icon.png": 68006,
	"./denmark-logo-icon.png": 99472,
	"./deportivo-alaves-logo-icon.png": 30943,
	"./dinamo-tbilisi-logo-icon.png": 56423,
	"./dinamo-zagreb-logo-icon.png": 32840,
	"./durban-city-logo-icon.png": 53314,
	"./dynamo-kyiv-logo-icon.png": 70332,
	"./ecuador-logo-icon.png": 31191,
	"./egypt-logo-icon.png": 79223,
	"./eintracht-frankfurt-logo-icon.png": 18530,
	"./elche-logo-icon.png": 30165,
	"./empoli-logo-icon.png": 47780,
	"./england-logo-icon.png": 22113,
	"./equatorial-guinea-logo-icon.png": 9121,
	"./espanyol-logo-icon.png": 5027,
	"./everton-logo-icon.png": 20257,
	"./ferencvaros-logo-icon.png": 1932,
	"./feyenoord-logo-icon.png": 92007,
	"./fiorentina-logo-icon.png": 5495,
	"./flora-logo-icon.png": 72664,
	"./france-logo-icon.png": 7801,
	"./frosinone-logo-icon.png": 37667,
	"./fulham-logo-icon.png": 67061,
	"./galatasaray-logo-icon.png": 22326,
	"./gambia-logo-icon.png": 15171,
	"./genoa-logo-icon.png": 68928,
	"./georgia-logo-icon.png": 2886,
	"./germany-logo-icon.png": 89245,
	"./getafe-logo-icon.png": 82382,
	"./ghana-logo-icon.png": 16375,
	"./girona-logo-icon.png": 79598,
	"./golden-arrows-logo-icon.png": 39552,
	"./granada-logo-icon.png": 15704,
	"./guinea-bissau-logo-icon.png": 28709,
	"./guinea-logo-icon.png": 29203,
	"./hacken-logo-icon.png": 40162,
	"./haiti-logo-icon.png": 11149,
	"./hamrun-spartans-logo-icon.png": 20096,
	"./hellas-verona-logo-icon.png": 405,
	"./hjk-logo-icon.png": 95703,
	"./hungary-logo-icon.png": 40484,
	"./internazionale-logo-icon.png": 17083,
	"./ipswich-town-logo-icon.png": 6052,
	"./iran-logo-icon.png": 14832,
	"./italy-logo-icon.png": 23015,
	"./jamaica-logo-icon.png": 96952,
	"./japan-logo-icon.png": 17594,
	"./juventus-logo-icon.png": 80754,
	"./kairat-logo-icon.png": 85662,
	"./kaizer-chiefs-logo-icon.png": 58465,
	"./ki-logo-icon.png": 70904,
	"./kobenhavn-logo-icon.png": 50402,
	"./korea-republic-logo-icon.png": 52611,
	"./larne-logo-icon.png": 82392,
	"./las-palmas-logo-icon.png": 17785,
	"./lazio-logo-icon.png": 37275,
	"./le-havre-logo-icon.png": 22016,
	"./lecce-logo-icon.png": 48374,
	"./leeds-united-logo-icon.png": 76899,
	"./leganes-logo-icon.png": 15255,
	"./leicester-city-logo-icon.png": 47102,
	"./lens-logo-icon.png": 14544,
	"./levante-logo-icon.png": 95699,
	"./lille-logo-icon.png": 576,
	"./lincoln-red-imps-logo-icon.png": 44909,
	"./liverpool-logo-icon.png": 23516,
	"./lorient-logo-icon.png": 90429,
	"./ludogorets-logo-icon.png": 42844,
	"./luton-town-logo-icon.png": 8285,
	"./maccabi-haifa-logo-icon.png": 25714,
	"./magesi-logo-icon.png": 65030,
	"./mali-logo-icon.png": 45147,
	"./mallorca-logo-icon.png": 42977,
	"./mamelodi-sundowns-logo-icon.png": 90020,
	"./manchester-city-logo-icon.png": 93112,
	"./manchester-united-logo-icon.png": 67800,
	"./maritzburg-united-logo-icon.png": 72533,
	"./marumo-gallants-logo-icon.png": 91022,
	"./mauritania-logo-icon.png": 14803,
	"./metz-logo-icon.png": 13216,
	"./mexico-logo-icon.png": 18733,
	"./milan-logo-icon.png": 75293,
	"./molde-logo-icon.png": 31223,
	"./monaco-logo-icon.png": 71025,
	"./montpellier-logo-icon.png": 24799,
	"./monza-logo-icon.png": 10975,
	"./morocco-logo-icon.png": 81912,
	"./mozambique-logo-icon.png": 74230,
	"./namibia-logo-icon.png": 17089,
	"./nantes-logo-icon.png": 40901,
	"./napoli-logo-icon.png": 12909,
	"./netherlands-logo-icon.png": 10578,
	"./new-zealand-logo-icon.png": 67184,
	"./newcastle-united-logo-icon.png": 26142,
	"./nice-logo-icon.png": 42731,
	"./nigeria-logo-icon.png": 65451,
	"./norway-logo-icon.png": 17146,
	"./norwich-logo-icon.png": 28754,
	"./nottingham-forest-logo-icon.png": 51865,
	"./olimpija-logo-icon.png": 12109,
	"./olympiakos-piraeus-logo-icon.png": 1316,
	"./olympique-lyonnais-logo-icon.png": 1339,
	"./olympique-marseille-logo-icon.png": 83306,
	"./orbit-college-logo-icon.png": 51958,
	"./orlando-pirates-logo-icon.png": 69168,
	"./osasuna-logo-icon.png": 25846,
	"./pafos-logo-icon.png": 21645,
	"./panama-logo-icon.png": 27980,
	"./panathinaikos-logo-icon.png": 84252,
	"./paris-fc-logo-icon.png": 87447,
	"./parma-logo-icon.png": 11705,
	"./partizani-tirana-logo-icon.png": 72852,
	"./philippines-logo-icon.png": 44311,
	"./pisa-logo-icon.png": 14121,
	"./poland-logo-icon.png": 8144,
	"./polokwane-city-logo-icon.png": 97508,
	"./porto-logo-icon.png": 36294,
	"./portugal-logo-icon.png": 27134,
	"./psg-logo-icon.png": 86320,
	"./psv-logo-icon.png": 9577,
	"./qarabag-logo-icon.png": 19251,
	"./qatar-logo-icon.png": 7309,
	"./rakow-czestochowa-logo-icon.png": 19229,
	"./rangers-logo-icon.png": 24764,
	"./rayo-vallecano-logo-icon.png": 14265,
	"./rb-leipzig-logo-icon.png": 69187,
	"./real-betis-logo-icon.png": 74466,
	"./real-madrid-logo-icon.png": 42100,
	"./real-oviedo-logo-icon.png": 53413,
	"./real-sociedad-logo-icon.png": 23069,
	"./real-valladolid-logo-icon.png": 66441,
	"./reims-logo-icon.png": 19450,
	"./rennes-logo-icon.png": 57047,
	"./republic-of-ireland-logo-icon.png": 42790,
	"./richards-bay-logo-icon.png": 2823,
	"./roma-logo-icon.png": 80975,
	"./romania-logo-icon.png": 6815,
	"./royal-am-logo-icon.png": 62648,
	"./saint-etienne-logo-icon.png": 49436,
	"./salernitana-logo-icon.png": 69626,
	"./salzburg-logo-icon.png": 75296,
	"./sampdoria-logo-icon.png": 61162,
	"./sassuolo-logo-icon.png": 79193,
	"./saudi-arabia-logo-icon.png": 33943,
	"./scotland-logo-icon.png": 5192,
	"./sekhukhune-united-logo-icon.png": 56039,
	"./senegal-logo-icon.png": 36451,
	"./serbia-logo-icon.png": 92830,
	"./servette-logo-icon.png": 35858,
	"./sevilla-logo-icon.png": 18010,
	"./shakhtar-donetsk-logo-icon.png": 52469,
	"./shamrock-rovers-logo-icon.png": 9024,
	"./sheffield-united-logo-icon.png": 4324,
	"./sheriff-logo-icon.png": 14607,
	"./siwelele-logo-icon.png": 25504,
	"./slavia-praha-logo-icon.png": 34691,
	"./slovakia-logo-icon.png": 62892,
	"./slovan-bratislava-logo-icon.png": 35163,
	"./slovenia-logo-icon.png": 14993,
	"./south-africa-logo-icon.png": 80926,
	"./southampton-logo-icon.png": 76816,
	"./spain-logo-icon.png": 89585,
	"./sparta-praha-logo-icon.png": 81152,
	"./spezia-logo-icon.png": 76814,
	"./sporting-braga-logo-icon.png": 13704,
	"./sporting-cp-logo-icon.png": 23344,
	"./stade-brestois-logo-icon.png": 77203,
	"./stellenbosch-logo-icon.png": 4900,
	"./strasbourg-logo-icon.png": 66132,
	"./struga-logo-icon.png": 47378,
	"./sturm-graz-logo-icon.png": 41308,
	"./stuttgart-logo-icon.png": 22190,
	"./sunderland-logo-icon.png": 27812,
	"./supersport-united-logo-icon.png": 8597,
	"./swallows-logo-icon.png": 76992,
	"./sweden-logo-icon.png": 97644,
	"./swift-hesperange-logo-icon.png": 18918,
	"./switzerland-logo-icon.png": 67137,
	"./tanzania-logo-icon.png": 88050,
	"./the-new-saints-logo-icon.png": 17319,
	"./torino-logo-icon.png": 35773,
	"./tottenham-hotspur-logo-icon.png": 85124,
	"./toulouse-logo-icon.png": 53848,
	"./trabzonspor-logo-icon.png": 42164,
	"./tre-penne-logo-icon.png": 19440,
	"./troyes-logo-icon.png": 82238,
	"./ts-galaxy-logo-icon.png": 57838,
	"./tsc-logo-icon.png": 31944,
	"./tunisia-logo-icon.png": 33469,
	"./turkey-logo-icon.png": 82162,
	"./udinese-logo-icon.png": 91037,
	"./ukraine-logo-icon.png": 91069,
	"./union-berlin-logo-icon.png": 8326,
	"./union-saint-gilloise-logo-icon.png": 21978,
	"./united-states-logo-icon.png": 41886,
	"./urartu-logo-icon.png": 32281,
	"./uruguay-logo-icon.png": 80630,
	"./valencia-logo-icon.png": 9509,
	"./valladolid-logo-icon.png": 44158,
	"./valmiera-logo-icon.png": 67519,
	"./venezia-logo-icon.png": 25246,
	"./vietnam-logo-icon.png": 84266,
	"./viitorul-logo-icon.png": 15916,
	"./viktoria-plzen-logo-icon.png": 26983,
	"./villarreal-logo-icon.png": 78382,
	"./wales-logo-icon.png": 10314,
	"./west-ham-united-logo-icon.png": 30654,
	"./wolverhampton-wanderers-logo-icon.png": 86542,
	"./young-boys-logo-icon.png": 60792,
	"./zalgiris-logo-icon.png": 3821,
	"./zambia-logo-icon.png": 32376,
	"./zrinjski-logo-icon.png": 56044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80987;